import React from "react";
import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { ErrorBoundary } from "../Common/ErrorBoundry";

//@ts-expect-error
const ChatPage = React.lazy(() => import("chat/ChatPage"));

export default function ChatPageWrapper() {
    const { id } = useParams()
    return (
        <ErrorBoundary>
            <Suspense fallback={'Loading...'}>
                <ChatPage />
            </Suspense>
        </ErrorBoundary>
    )
}
